import { API } from "./api";

const FILES_ORIGIN = API.replace(/\/api\/?$/, "");

export function abs(url) {
  if (!url) return "";
  return /^https?:\/\//.test(url) ? url : `${FILES_ORIGIN}${url}`;
}

/**
 * Inject a tenant's brand into the running page: CSS custom properties, the
 * document title, and the favicon.  `branding` is the object returned by
 * /api/auth/institution or /api/tenant/branding (or config.institution.branding).
 */
export function applyTheme({ branding = {}, name, title } = {}) {
  const root = document.documentElement;
  if (branding.primary_color) root.style.setProperty("--brand-primary", branding.primary_color);
  if (branding.accent_color) root.style.setProperty("--brand-accent", branding.accent_color);

  const pageTitle = title || name;
  if (pageTitle) document.title = pageTitle;

  if (branding.favicon_url) {
    const href = abs(branding.favicon_url);
    let link = document.querySelector('link[rel~="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = `${href}?v=${Date.now()}`;
  }
}

export const brandLogoUrl = (branding) => abs(branding?.logo_url);
